/**
 * i18n config — react-i18next với language detector + localStorage.
 *
 * Mặc định VI. EN là ngôn ngữ thứ 2. Switcher đặt trong TopBar (PublicShell).
 * Persist locale qua localStorage key `i18nextLng`.
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import vi from './locales/vi.json'
import en from './locales/en.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'vi',
    supportedLngs: ['vi', 'en'],
    resources: {
      vi: { translation: vi },
      en: { translation: en },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: { escapeValue: false },
    returnNull: false,
  })

export default i18n
